export enum FreightRuleType {
    First = "First",
    NoFreeFreight = "NoFreeFreight",
    TraditionalPart = "TraditionalPart",
    BaldwinDirect = "BaldwinDirect",
    BatteriesStarter = "BatteriesStarter",
    BatteriesPalletPro = "BatteriesPalletPro",
    BatteriesIndustrial = "BatteriesIndustrial",
    Forks = "Forks",
    PalletJack1 = "PalletJack1",
    PalletJackA9556 = "PalletJackA9556",
    PalletJackA14719 = "PalletJackA14719",
    LPTanks = "LPTanks",
    Tires = "Tires",
    MCFAForks = "MCFAForks",
    MCFA = "MCFA",
    CascadeSideshift = "CascadeSideshift",
    Last = "Last",
    None = "None",
}
